import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import ReactModal from 'react-modal';
import React from 'react';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  modal: {
    transform: 'translateY(200px)',
    overflow: 'auto',
    transition: 'transform 100ms ease-in-out',

    '&.ReactModal__Content--after-open': {
      transform: 'translateY(0)',
    },
    '&.ReactModal__Content--before-close': {
      transform: 'translateY(200px)',
    },
  },
  overlay: {
    ...theme.absoluteFill,
    position: 'fixed',
    backgroundColor: theme.basicColors.inkPrimary.fade(0.5).toString(),
    opacity: 0,
    zIndex: 1500, // same as tooltips
    transition: 'opacity 100ms ease-in-out',

    '&.ReactModal__Overlay--after-open': {
      opacity: 1,
    },
    '&.ReactModal__Overlay--before-close': {
      opacity: 0,
    },
  },
}));

type Props = ReactModal.Props & { children: React.ReactNode };

export const Modal = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  return (
    <ReactModal
      closeTimeoutMS={100}
      {...props}
      className={classnames(props.className, classes.modal)}
      overlayClassName={classnames(props.overlayClassName, classes.overlay)}
    />
  );
};
